const productIdentity = (product = {}) => String(
  product?.cartLineId ??
  product?.orderItemId ??
  product?.OrderItemId ??
  product?.id ??
  "",
);

export const commitSalesOrderWorkspaceProductListMutation = async ({
  currentProducts = [],
  nextProducts = [],
  mutationHandlers,
  onWorkspaceMutationCommitted,
}) => {
  let mutationType;
  let mutationResult;
  let metadata;

  if (nextProducts.length === currentProducts.length + 1) {
    const product = nextProducts[nextProducts.length - 1];
    mutationType = "add-product";
    mutationResult = mutationHandlers?.addProduct?.(product);
    metadata = { product };
  } else if (nextProducts.length === currentProducts.length - 1) {
    const nextIdentities = new Set(nextProducts.map(productIdentity));
    const product = currentProducts.find(
      (candidate) => !nextIdentities.has(productIdentity(candidate)),
    );
    mutationType = "delete-product";
    mutationResult = product
      ? mutationHandlers?.deleteProduct?.(product)
      : { ok: false, reason: "product-identity-not-found" };
    metadata = { identity: product };
  } else {
    mutationResult = { ok: false, reason: "unsupported-product-list-mutation" };
  }

  if (!mutationResult?.ok) return mutationResult;

  await onWorkspaceMutationCommitted?.({
    source: "sales-order-cart",
    mutationType,
    nextPayload: mutationResult.payload,
    metadata,
  });
  return mutationResult;
};
